import React from "react";
import PropTypes from "prop-types";
import { Chevron } from "../../../reusableComponents/Chevron/index.js";
import { MobileHeaderContainer, HeaderTitle } from "./styles.js";

const ProductsMobileHeader = ({ productName, isOpen }) => {
  return (
    <MobileHeaderContainer>
      <Chevron isOpen={isOpen}></Chevron>
      <HeaderTitle>{productName}</HeaderTitle>
    </MobileHeaderContainer>
  );
};
ProductsMobileHeader.propTypes = {
  productName: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
};
export default ProductsMobileHeader;
